import React from 'react';
import './About.css';

const values = [
	{
		color: '#3aafa9',
		title: 'Fixed-price clarity',
		desc: 'No surprise overages. Scope changes go through a formal change order.',
	},
	{
		color: '#3a7fc1',
		title: 'Knowledge transfer',
		desc: "We document and train — you own it long after we're gone.",
	},
	{
		color: '#7b5ea7',
		title: 'Remote-first ready',
		desc: 'Async-capable and experienced with distributed engineering teams.',
	},
	{
		color: '#e05c2a',
		title: 'No junior hand-offs',
		desc: 'Senior expertise on every engagement, start to finish.',
	},
];

const models = [
	{
		bg: '#1e3a2a',
		title: 'Fixed-Price Project',
		desc: 'Scoped migrations, pipeline builds, and security implementations. Clear deliverables, clear price.',
	},
	{
		bg: '#1e2e45',
		title: 'Time & Materials',
		desc: 'Ongoing advisory, optimization, and staff augmentation at a transparent hourly rate.',
	},
	{
		bg: '#2a1e45',
		title: 'Monthly Retainer',
		desc: 'Dedicated hours each month for continuous improvement and on-call advisory.',
	},
];

export default function About() {
	return (
		<section className='about' id='about'>
			<div className='about__inner'>
				<div className='about__left'>
					<div className='section-eyebrow' style={{ color: '#6db33f' }}>
						HOW WE WORK
					</div>
					<h2 className='section-heading' style={{ color: '#fff' }}>
						Scoped. Accountable.
						<br />
						Built to transfer.
					</h2>
					<p className='about__body'>
						Every engagement comes with a clear statement of work, defined
						deliverables, and a knowledge transfer built in. You own the outcome
						— not just the invoice.
					</p>
					<p className='about__body'>
						We document everything, train your team, and hand off in a way that
						actually sticks.
					</p>
					<div className='about__values'>
						{values.map((v) => (
							<div className='val-card' key={v.title}>
								<div
									className='val-card__dot'
									style={{ background: v.color }}
								/>
								<h4 className='val-card__title'>{v.title}</h4>
								<p className='val-card__desc'>{v.desc}</p>
							</div>
						))}
					</div>
				</div>

				<div className='about__right'>
					<div className='models__label'>ENGAGEMENT MODELS</div>
					{models.map((m) => (
						<div className='model-item' key={m.title}>
							<div className='model-item__icon' style={{ background: m.bg }}>
								◈
							</div>
							<div>
								<h4 className='model-item__title'>{m.title}</h4>
								<p className='model-item__desc'>{m.desc}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
